export class DeviceScans
{
    constructor(public name: string, public snr: string, public totalScans: number, public estAlarmCount: number, public device: any)
    {

    }

    public getPercentage(): number
    {
        if (this.totalScans > 0)
        {
            return (100 - (100 * this.estAlarmCount / this.totalScans));
        }
        else
        {
            return -1;
        }
    }

    public getInfo(): string
    {
        let totals: string = `Total: ${this.totalScans}, Alarms: ${this.estAlarmCount}`;
        let percentage: string = `(${Math.round(100 * this.estAlarmCount / this.totalScans)}%)`;

        return (this.totalScans > 0 ? (`${totals} - ${percentage}`) : totals);
    }

    public getTotalSuccess()
    {
        return this.totalScans - this.estAlarmCount;
    }

    public getTotalAlarms()
    {
        return this.estAlarmCount;
    }
}

export class ScanHolder
{
    scanCount: number = 0;
    alarmCount: number = 0;

    constructor(public name: string = "", public tag: any = null)
    {

    }
}